import React, { FC } from "react";
import "./index.scss";
import { getHexColor } from "../../helpers";

interface INews {
  title: string;
  buttonLink: string;
  buttonTextColor?: string;
  buttonColor?: string;
  buttonText: string;
  buttonTarget: string;
}

interface Props {
  title: string;
  link: string;
  linkTarget: string;
  newsItems: INews[];
}

const getButtonStyle = ({
  buttonTextColor,
  buttonColor
}: Partial<INews>): Record<string, string> => {
  return {
    "--news-buttonColor": buttonColor
      ? getHexColor(buttonColor)
      : "var(--color-yellow)",
    "--news-buttonTextColor": buttonTextColor
      ? getHexColor(buttonTextColor)
      : "var(--color-black)"
  };
};

const News: FC<Props> = ({
  title = "News",
  link,
  linkTarget = "_self",
  newsItems: list = []
}) => {
  return (
    <div className="news">
      <a className="news__title" href={link} target={linkTarget}>
        {title}
        <svg width="8" height="12" viewBox="0 0 8 12" fill="none">
          <path
            d="M0 10.59L4.94467 6L0 1.41L1.52227 0L8 6L1.52227 12L0 10.59Z"
            fill="currentColor"
          />
        </svg>
      </a>
      <div className="news__list">
        {list.map(
          (
            {
              title,
              buttonLink,
              buttonTarget = "self",
              buttonText,
              buttonColor,
              buttonTextColor
            },
            key
          ) => (
            <a
              className="news__list-block"
              key={`news-${key}`}
              target={buttonTarget}
              href={buttonLink}
            >
              <div className="news__list--title">{title}</div>
              <div
                className="news__list--btn"
                style={getButtonStyle({ buttonTextColor, buttonColor })}
              >
                {buttonText}
              </div>
            </a>
          )
        )}
      </div>
    </div>
  );
};

export default News;
